export default __webpack_public_path__ + "static/media/bg5.cbc722d8.png";